import { InjectableClass } from '@fino/lib-injection';
import _ from 'lodash';

export class ConfirmService extends InjectableClass {
  constructor(cardService) {
    'ngInject';
    super({ cardService });
  }

  prepareFinances(financeData) {
    // Filter out ignored contracts

    financeData.finances.directDebits.map((item) => {
      item.contracts = _.filter(item.contracts, (c) => c.active);
      return item;
    });

    financeData.finances.receivedPayments.map((item) => {
      item.contracts = _.filter(item.contracts, (c) => c.active);
      return item;
    });

    return financeData;
  }

  getPaymentPartnerOverviewData(financeData) {
    const partners = this.prepareFinances(financeData).finances;
    return _.flatMap(partners, (x) =>
      _.compact(
        _.map(x, (x) => {
          if (x.ignoreOnPrint) return null;
          const p = _.merge(x, x.partner);
          p.name = p.name || p.header;
          return p;
        }),
      ),
    );
  }

  getPaymentPartnerStatisticsFromFinances(finances) {
    let { directDebits, receivedPayments } = finances;
    return {
      total: directDebits.length + receivedPayments.length,
      directDebitsTotal: directDebits.length,
      directDebitsIncomplete: _.filter(
        directDebits,
        (data) => !this.cardService.hasAddressData(data),
      ).length,
      directDebitsIgnored: _.filter(directDebits, (data) => data.ignoreOnPrint)
        .length,
      directDebitsAdded: _.filter(directDebits, (data) => data.isAdded).length,
      receivedPaymentsTotal: receivedPayments.length,
      receivedPaymentsIncomplete: _.filter(
        receivedPayments,
        (data) => !this.cardService.hasAddressData(data),
      ).length,
      receivedPaymentsIgnored: _.filter(
        receivedPayments,
        (data) => data.ignoreOnPrint,
      ).length,
      receivedPaymentsAdded: _.filter(receivedPayments, (data) => data.isAdded)
        .length,
    };
  }
}
